import { render, staticRenderFns } from "./AmapH5.vue?vue&type=template&id=90c5979a&scoped=true&"
import script from "./AmapH5.vue?vue&type=script&lang=js&"
export * from "./AmapH5.vue?vue&type=script&lang=js&"
import style0 from "./AmapH5.vue?vue&type=style&index=0&id=90c5979a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c5979a",
  null
  
)

export default component.exports